// Lightweight confetti hook — no external deps
const Confetti = {
  mounted() {
    this.launch();
  },
  launch() {
    const canvas = document.createElement("canvas");
    canvas.style.cssText =
      "position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;";
    document.body.appendChild(canvas);
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const colors = [
      "#6366f1", "#8b5cf6", "#ec4899", "#f59e0b", "#10b981",
      "#3b82f6", "#ef4444", "#f97316", "#14b8a6", "#a855f7",
    ];

    const particles = Array.from({ length: 120 }, () => ({
      x: Math.random() * canvas.width,
      y: -10 - Math.random() * 100,
      r: 4 + Math.random() * 6,
      color: colors[Math.floor(Math.random() * colors.length)],
      vx: (Math.random() - 0.5) * 3,
      vy: 2 + Math.random() * 4,
      angle: Math.random() * Math.PI * 2,
      spin: (Math.random() - 0.5) * 0.15,
      shape: Math.random() > 0.5 ? "rect" : "circle",
    }));

    this._frame = null;
    this._done = false;
    this._canvas = canvas;

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      let allGone = true;

      for (const p of particles) {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.05; // gravity
        p.angle += p.spin;

        if (p.y < canvas.height + 20) allGone = false;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.angle);
        ctx.fillStyle = p.color;
        ctx.globalAlpha = Math.max(0, 1 - (p.y / canvas.height) * 0.5);

        if (p.shape === "rect") {
          ctx.fillRect(-p.r, -p.r / 2, p.r * 2, p.r);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, p.r / 2, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      }

      if (!allGone && !this._done) {
        this._frame = requestAnimationFrame(draw);
      } else {
        this._cleanup();
      }
    };

    this._frame = requestAnimationFrame(draw);

    // Clean up after 4s regardless
    this._timeout = setTimeout(() => {
      this._cleanup();
    }, 4000);
  },
  _cleanup() {
    if (this._done) return;
    this._done = true;
    cancelAnimationFrame(this._frame);
    clearTimeout(this._timeout);
    if (this._canvas && this._canvas.parentNode) {
      this._canvas.remove();
    }
  },
  destroyed() {
    this._cleanup();
  },
};

export default Confetti;
